import axios from "axios";

export const httpClient = axios.create({
  baseURL: `https://www.impeltechnology.com/rest/api/`,
  //baseURL: `https://cors-anywhere.herokuapp.com/https://www.impeltechnology.com/rest/api/`, 
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
